import React from 'react';
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "../axios";
import { Services } from "../api/api";

import Dashboard from "../Dashboard";
import {
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

export default function ServiceCreate() {
  const navigation = useNavigate();
  const [service, setService] = useState<Services>({});

  const handleCreate = () => {
    console.log("Create");
    axios
      .post("/services", service)
      .then((res) => {
        console.log("post result:" + res);
        navigation("/services");
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  const handleChangeServiceId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setService({ ...service, service_id: event.target.value });
  };

  const handleChangeServiceName = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setService({ ...service, service_name: event.target.value });
  };

  const handleChangeMemo = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setService({ ...service, memo: event.target.value });
  };

  return (
    <Dashboard title="サービス登録">
      <Table >
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="サービスID"
                variant="outlined"
                required
                fullWidth
                value={service.service_id}
                onChange={handleChangeServiceId}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="サービス名"
                variant="outlined"
                required
                fullWidth
                value={service.service_name}
                onChange={handleChangeServiceName}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="備考"
                variant="outlined"
                required
                multiline
                fullWidth
                value={service.memo}
                onChange={handleChangeMemo}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleCreate} sx={{ m: 1 }}>
          CREATE
        </Button>
      </Grid>
    </Dashboard>
  );
}
